import { useModal, withModalConditionalRender } from '@billy/design-system'
import { CreditCardIcon } from 'lucide-react'

import { useRegisterBillPayment } from '@features/bills/hooks/useRegisterBillPayment'

import { BillReconciliationModal as BillReconciliationModalComponent } from '../../../../../BillReconciliationModal'
import { BillsTableRow } from '../../../../types/billsTableRow'
import { BillsTableActionType } from '../../enums/billsTableActionType'
import { BillsTableAction } from '../../types/billsTableAction'

const BillReconciliationModal = withModalConditionalRender(BillReconciliationModalComponent)

const getRegisterPaymentModalId = (billId: string) => `${billId}-bills-table-register-payment`

/**
 * @todo Handle localization
 * @see https://linear.app/shine-co/issue/EXP-357/web-add-localization
 */
export const useRegisterPaymentAction = (row: BillsTableRow): BillsTableAction => {
  const modalId = getRegisterPaymentModalId(row.id)
  const { open: openBillReconciliationModal } = useModal(modalId)

  const { handleRegisterPayment } = useRegisterBillPayment({
    bill: row.bill,
    openReconciliationModal: openBillReconciliationModal,
  })

  return {
    type: BillsTableActionType.RegisterPayment,
    label: 'Register payment',
    icon: CreditCardIcon,
    onClick: handleRegisterPayment,
    // The reconciliation modal requires the full bill, see `BillsTableRow.bill`
    confirmationModal: <BillReconciliationModal subject={row.bill} id={modalId} />,
  }
}
